import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  user: [],
  error: null,
};

const ProofreaderRoleEditorSubmitReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.PROOFREADER_ROLE_EDITOR_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.PROOFREADER_ROLE_EDITOR_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default ProofreaderRoleEditorSubmitReducer;
